/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PrivateRouteRouteImport } from './routes/_private/route'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PrivateSuppliersRouteImport } from './routes/_private/suppliers'
import { Route as PrivateSettingsRouteImport } from './routes/_private/settings'
import { Route as PrivateProductsRouteImport } from './routes/_private/products'
import { Route as PrivateDashboardRouteImport } from './routes/_private/dashboard'
import { Route as PrivateClientsRouteImport } from './routes/_private/clients'
import { Route as PrivateUsersRouteRouteImport } from './routes/_private/users/route'
import { Route as PrivateIgoldTransactionsRouteRouteImport } from './routes/_private/igold-transactions/route'
import { Route as PrivateIcashTransactionsRouteRouteImport } from './routes/_private/icash-transactions/route'
import { Route as PrivateEmployeesRouteRouteImport } from './routes/_private/employees/route'
import { Route as PrivateAteliersRouteRouteImport } from './routes/_private/ateliers/route'
import { Route as PrivateUsersIndexRouteImport } from './routes/_private/users/index'
import { Route as PrivateIgoldTransactionsIndexRouteImport } from './routes/_private/igold-transactions/index'
import { Route as PrivateIcashTransactionsIndexRouteImport } from './routes/_private/icash-transactions/index'
import { Route as PrivateEmployeesIndexRouteImport } from './routes/_private/employees/index'
import { Route as PrivateAteliersIndexRouteImport } from './routes/_private/ateliers/index'
import { Route as PublicAuthCallbackRouteImport } from './routes/_public/auth/callback'
import { Route as PrivateUsersUserIdRouteRouteImport } from './routes/_private/users/$userId/route'
import { Route as PrivateEmployeesEmployeeIdRouteRouteImport } from './routes/_private/employees/$employeeId/route'
import { Route as PrivateAteliersAtelierIdRouteRouteImport } from './routes/_private/ateliers/$atelierId/route'
import { Route as PrivateUsersUserIdIndexRouteImport } from './routes/_private/users/$userId/index'
import { Route as PrivateEmployeesEmployeeIdIndexRouteImport } from './routes/_private/employees/$employeeId/index'
import { Route as PrivateAteliersAtelierIdIndexRouteImport } from './routes/_private/ateliers/$atelierId/index'
import { Route as PrivateUsersUserIdIgoldTransactionsIndexRouteImport } from './routes/_private/users/$userId/igold-transactions/index'
import { Route as PrivateUsersUserIdIcashTransactionsIndexRouteImport } from './routes/_private/users/$userId/icash-transactions/index'
import { Route as PrivateEmployeesEmployeeIdSalariesIndexRouteImport } from './routes/_private/employees/$employeeId/salaries/index'
import { Route as PrivateEmployeesEmployeeIdIgoldTransactionsIndexRouteImport } from './routes/_private/employees/$employeeId/igold-transactions/index'
import { Route as PrivateEmployeesEmployeeIdIcashTransactionsIndexRouteImport } from './routes/_private/employees/$employeeId/icash-transactions/index'
import { Route as PrivateAteliersAtelierIdIgoldTransactionsIndexRouteImport } from './routes/_private/ateliers/$atelierId/igold-transactions/index'
import { Route as PrivateAteliersAtelierIdIcashTransactionsIndexRouteImport } from './routes/_private/ateliers/$atelierId/icash-transactions/index'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicTermsRoute = PublicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateSuppliersRoute = PrivateSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateSettingsRoute = PrivateSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateProductsRoute = PrivateProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateDashboardRoute = PrivateDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateClientsRoute = PrivateClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateUsersRouteRoute = PrivateUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateIgoldTransactionsRouteRoute =
  PrivateIgoldTransactionsRouteRouteImport.update({
    id: '/igold-transactions',
    path: '/igold-transactions',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateIcashTransactionsRouteRoute =
  PrivateIcashTransactionsRouteRouteImport.update({
    id: '/icash-transactions',
    path: '/icash-transactions',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEmployeesRouteRoute = PrivateEmployeesRouteRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateAteliersRouteRoute = PrivateAteliersRouteRouteImport.update({
  id: '/ateliers',
  path: '/ateliers',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateUsersIndexRoute = PrivateUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateUsersRouteRoute,
} as any)
const PrivateIgoldTransactionsIndexRoute =
  PrivateIgoldTransactionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateIgoldTransactionsRouteRoute,
  } as any)
const PrivateIcashTransactionsIndexRoute =
  PrivateIcashTransactionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateIcashTransactionsRouteRoute,
  } as any)
const PrivateEmployeesIndexRoute = PrivateEmployeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateEmployeesRouteRoute,
} as any)
const PrivateAteliersIndexRoute = PrivateAteliersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateAteliersRouteRoute,
} as any)
const PublicAuthCallbackRoute = PublicAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateUsersUserIdRouteRoute = PrivateUsersUserIdRouteRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => PrivateUsersRouteRoute,
} as any)
const PrivateEmployeesEmployeeIdRouteRoute =
  PrivateEmployeesEmployeeIdRouteRouteImport.update({
    id: '/$employeeId',
    path: '/$employeeId',
    getParentRoute: () => PrivateEmployeesRouteRoute,
  } as any)
const PrivateAteliersAtelierIdRouteRoute =
  PrivateAteliersAtelierIdRouteRouteImport.update({
    id: '/$atelierId',
    path: '/$atelierId',
    getParentRoute: () => PrivateAteliersRouteRoute,
  } as any)
const PrivateUsersUserIdIndexRoute = PrivateUsersUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateUsersUserIdRouteRoute,
} as any)
const PrivateEmployeesEmployeeIdIndexRoute =
  PrivateEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateEmployeesEmployeeIdRouteRoute,
  } as any)
const PrivateAteliersAtelierIdIndexRoute =
  PrivateAteliersAtelierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateAteliersAtelierIdRouteRoute,
  } as any)
const PrivateUsersUserIdIgoldTransactionsIndexRoute =
  PrivateUsersUserIdIgoldTransactionsIndexRouteImport.update({
    id: '/igold-transactions/',
    path: '/igold-transactions/',
    getParentRoute: () => PrivateUsersUserIdRouteRoute,
  } as any)
const PrivateUsersUserIdIcashTransactionsIndexRoute =
  PrivateUsersUserIdIcashTransactionsIndexRouteImport.update({
    id: '/icash-transactions/',
    path: '/icash-transactions/',
    getParentRoute: () => PrivateUsersUserIdRouteRoute,
  } as any)
const PrivateEmployeesEmployeeIdSalariesIndexRoute =
  PrivateEmployeesEmployeeIdSalariesIndexRouteImport.update({
    id: '/salaries/',
    path: '/salaries/',
    getParentRoute: () => PrivateEmployeesEmployeeIdRouteRoute,
  } as any)
const PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute =
  PrivateEmployeesEmployeeIdIgoldTransactionsIndexRouteImport.update({
    id: '/igold-transactions/',
    path: '/igold-transactions/',
    getParentRoute: () => PrivateEmployeesEmployeeIdRouteRoute,
  } as any)
const PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute =
  PrivateEmployeesEmployeeIdIcashTransactionsIndexRouteImport.update({
    id: '/icash-transactions/',
    path: '/icash-transactions/',
    getParentRoute: () => PrivateEmployeesEmployeeIdRouteRoute,
  } as any)
const PrivateAteliersAtelierIdIgoldTransactionsIndexRoute =
  PrivateAteliersAtelierIdIgoldTransactionsIndexRouteImport.update({
    id: '/igold-transactions/',
    path: '/igold-transactions/',
    getParentRoute: () => PrivateAteliersAtelierIdRouteRoute,
  } as any)
const PrivateAteliersAtelierIdIcashTransactionsIndexRoute =
  PrivateAteliersAtelierIdIcashTransactionsIndexRouteImport.update({
    id: '/icash-transactions/',
    path: '/icash-transactions/',
    getParentRoute: () => PrivateAteliersAtelierIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/ateliers': typeof PrivateAteliersRouteRouteWithChildren
  '/employees': typeof PrivateEmployeesRouteRouteWithChildren
  '/icash-transactions': typeof PrivateIcashTransactionsRouteRouteWithChildren
  '/igold-transactions': typeof PrivateIgoldTransactionsRouteRouteWithChildren
  '/users': typeof PrivateUsersRouteRouteWithChildren
  '/clients': typeof PrivateClientsRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/products': typeof PrivateProductsRoute
  '/settings': typeof PrivateSettingsRoute
  '/suppliers': typeof PrivateSuppliersRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/': typeof PublicIndexRoute
  '/ateliers/$atelierId': typeof PrivateAteliersAtelierIdRouteRouteWithChildren
  '/employees/$employeeId': typeof PrivateEmployeesEmployeeIdRouteRouteWithChildren
  '/users/$userId': typeof PrivateUsersUserIdRouteRouteWithChildren
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/ateliers/': typeof PrivateAteliersIndexRoute
  '/employees/': typeof PrivateEmployeesIndexRoute
  '/icash-transactions/': typeof PrivateIcashTransactionsIndexRoute
  '/igold-transactions/': typeof PrivateIgoldTransactionsIndexRoute
  '/users/': typeof PrivateUsersIndexRoute
  '/ateliers/$atelierId/': typeof PrivateAteliersAtelierIdIndexRoute
  '/employees/$employeeId/': typeof PrivateEmployeesEmployeeIdIndexRoute
  '/users/$userId/': typeof PrivateUsersUserIdIndexRoute
  '/ateliers/$atelierId/icash-transactions': typeof PrivateAteliersAtelierIdIcashTransactionsIndexRoute
  '/ateliers/$atelierId/igold-transactions': typeof PrivateAteliersAtelierIdIgoldTransactionsIndexRoute
  '/employees/$employeeId/icash-transactions': typeof PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute
  '/employees/$employeeId/igold-transactions': typeof PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute
  '/employees/$employeeId/salaries': typeof PrivateEmployeesEmployeeIdSalariesIndexRoute
  '/users/$userId/icash-transactions': typeof PrivateUsersUserIdIcashTransactionsIndexRoute
  '/users/$userId/igold-transactions': typeof PrivateUsersUserIdIgoldTransactionsIndexRoute
}
export interface FileRoutesByTo {
  '/clients': typeof PrivateClientsRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/products': typeof PrivateProductsRoute
  '/settings': typeof PrivateSettingsRoute
  '/suppliers': typeof PrivateSuppliersRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/': typeof PublicIndexRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/ateliers': typeof PrivateAteliersIndexRoute
  '/employees': typeof PrivateEmployeesIndexRoute
  '/icash-transactions': typeof PrivateIcashTransactionsIndexRoute
  '/igold-transactions': typeof PrivateIgoldTransactionsIndexRoute
  '/users': typeof PrivateUsersIndexRoute
  '/ateliers/$atelierId': typeof PrivateAteliersAtelierIdIndexRoute
  '/employees/$employeeId': typeof PrivateEmployeesEmployeeIdIndexRoute
  '/users/$userId': typeof PrivateUsersUserIdIndexRoute
  '/ateliers/$atelierId/icash-transactions': typeof PrivateAteliersAtelierIdIcashTransactionsIndexRoute
  '/ateliers/$atelierId/igold-transactions': typeof PrivateAteliersAtelierIdIgoldTransactionsIndexRoute
  '/employees/$employeeId/icash-transactions': typeof PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute
  '/employees/$employeeId/igold-transactions': typeof PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute
  '/employees/$employeeId/salaries': typeof PrivateEmployeesEmployeeIdSalariesIndexRoute
  '/users/$userId/icash-transactions': typeof PrivateUsersUserIdIcashTransactionsIndexRoute
  '/users/$userId/igold-transactions': typeof PrivateUsersUserIdIgoldTransactionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_private/ateliers': typeof PrivateAteliersRouteRouteWithChildren
  '/_private/employees': typeof PrivateEmployeesRouteRouteWithChildren
  '/_private/icash-transactions': typeof PrivateIcashTransactionsRouteRouteWithChildren
  '/_private/igold-transactions': typeof PrivateIgoldTransactionsRouteRouteWithChildren
  '/_private/users': typeof PrivateUsersRouteRouteWithChildren
  '/_private/clients': typeof PrivateClientsRoute
  '/_private/dashboard': typeof PrivateDashboardRoute
  '/_private/products': typeof PrivateProductsRoute
  '/_private/settings': typeof PrivateSettingsRoute
  '/_private/suppliers': typeof PrivateSuppliersRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/terms': typeof PublicTermsRoute
  '/_public/': typeof PublicIndexRoute
  '/_private/ateliers/$atelierId': typeof PrivateAteliersAtelierIdRouteRouteWithChildren
  '/_private/employees/$employeeId': typeof PrivateEmployeesEmployeeIdRouteRouteWithChildren
  '/_private/users/$userId': typeof PrivateUsersUserIdRouteRouteWithChildren
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_private/ateliers/': typeof PrivateAteliersIndexRoute
  '/_private/employees/': typeof PrivateEmployeesIndexRoute
  '/_private/icash-transactions/': typeof PrivateIcashTransactionsIndexRoute
  '/_private/igold-transactions/': typeof PrivateIgoldTransactionsIndexRoute
  '/_private/users/': typeof PrivateUsersIndexRoute
  '/_private/ateliers/$atelierId/': typeof PrivateAteliersAtelierIdIndexRoute
  '/_private/employees/$employeeId/': typeof PrivateEmployeesEmployeeIdIndexRoute
  '/_private/users/$userId/': typeof PrivateUsersUserIdIndexRoute
  '/_private/ateliers/$atelierId/icash-transactions/': typeof PrivateAteliersAtelierIdIcashTransactionsIndexRoute
  '/_private/ateliers/$atelierId/igold-transactions/': typeof PrivateAteliersAtelierIdIgoldTransactionsIndexRoute
  '/_private/employees/$employeeId/icash-transactions/': typeof PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute
  '/_private/employees/$employeeId/igold-transactions/': typeof PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute
  '/_private/employees/$employeeId/salaries/': typeof PrivateEmployeesEmployeeIdSalariesIndexRoute
  '/_private/users/$userId/icash-transactions/': typeof PrivateUsersUserIdIcashTransactionsIndexRoute
  '/_private/users/$userId/igold-transactions/': typeof PrivateUsersUserIdIgoldTransactionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/ateliers'
    | '/employees'
    | '/icash-transactions'
    | '/igold-transactions'
    | '/users'
    | '/clients'
    | '/dashboard'
    | '/products'
    | '/settings'
    | '/suppliers'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/'
    | '/ateliers/$atelierId'
    | '/employees/$employeeId'
    | '/users/$userId'
    | '/auth/callback'
    | '/ateliers/'
    | '/employees/'
    | '/icash-transactions/'
    | '/igold-transactions/'
    | '/users/'
    | '/ateliers/$atelierId/'
    | '/employees/$employeeId/'
    | '/users/$userId/'
    | '/ateliers/$atelierId/icash-transactions'
    | '/ateliers/$atelierId/igold-transactions'
    | '/employees/$employeeId/icash-transactions'
    | '/employees/$employeeId/igold-transactions'
    | '/employees/$employeeId/salaries'
    | '/users/$userId/icash-transactions'
    | '/users/$userId/igold-transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clients'
    | '/dashboard'
    | '/products'
    | '/settings'
    | '/suppliers'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/'
    | '/auth/callback'
    | '/ateliers'
    | '/employees'
    | '/icash-transactions'
    | '/igold-transactions'
    | '/users'
    | '/ateliers/$atelierId'
    | '/employees/$employeeId'
    | '/users/$userId'
    | '/ateliers/$atelierId/icash-transactions'
    | '/ateliers/$atelierId/igold-transactions'
    | '/employees/$employeeId/icash-transactions'
    | '/employees/$employeeId/igold-transactions'
    | '/employees/$employeeId/salaries'
    | '/users/$userId/icash-transactions'
    | '/users/$userId/igold-transactions'
  id:
    | '__root__'
    | '/_private'
    | '/_public'
    | '/_private/ateliers'
    | '/_private/employees'
    | '/_private/icash-transactions'
    | '/_private/igold-transactions'
    | '/_private/users'
    | '/_private/clients'
    | '/_private/dashboard'
    | '/_private/products'
    | '/_private/settings'
    | '/_private/suppliers'
    | '/_public/login'
    | '/_public/privacy'
    | '/_public/terms'
    | '/_public/'
    | '/_private/ateliers/$atelierId'
    | '/_private/employees/$employeeId'
    | '/_private/users/$userId'
    | '/_public/auth/callback'
    | '/_private/ateliers/'
    | '/_private/employees/'
    | '/_private/icash-transactions/'
    | '/_private/igold-transactions/'
    | '/_private/users/'
    | '/_private/ateliers/$atelierId/'
    | '/_private/employees/$employeeId/'
    | '/_private/users/$userId/'
    | '/_private/ateliers/$atelierId/icash-transactions/'
    | '/_private/ateliers/$atelierId/igold-transactions/'
    | '/_private/employees/$employeeId/icash-transactions/'
    | '/_private/employees/$employeeId/igold-transactions/'
    | '/_private/employees/$employeeId/salaries/'
    | '/_private/users/$userId/icash-transactions/'
    | '/_private/users/$userId/igold-transactions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/terms': {
      id: '/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicTermsRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/suppliers': {
      id: '/_private/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof PrivateSuppliersRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/settings': {
      id: '/_private/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/products': {
      id: '/_private/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof PrivateProductsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/dashboard': {
      id: '/_private/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/clients': {
      id: '/_private/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof PrivateClientsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/users': {
      id: '/_private/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof PrivateUsersRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/igold-transactions': {
      id: '/_private/igold-transactions'
      path: '/igold-transactions'
      fullPath: '/igold-transactions'
      preLoaderRoute: typeof PrivateIgoldTransactionsRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/icash-transactions': {
      id: '/_private/icash-transactions'
      path: '/icash-transactions'
      fullPath: '/icash-transactions'
      preLoaderRoute: typeof PrivateIcashTransactionsRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/employees': {
      id: '/_private/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof PrivateEmployeesRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/ateliers': {
      id: '/_private/ateliers'
      path: '/ateliers'
      fullPath: '/ateliers'
      preLoaderRoute: typeof PrivateAteliersRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/users/': {
      id: '/_private/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof PrivateUsersIndexRouteImport
      parentRoute: typeof PrivateUsersRouteRoute
    }
    '/_private/igold-transactions/': {
      id: '/_private/igold-transactions/'
      path: '/'
      fullPath: '/igold-transactions/'
      preLoaderRoute: typeof PrivateIgoldTransactionsIndexRouteImport
      parentRoute: typeof PrivateIgoldTransactionsRouteRoute
    }
    '/_private/icash-transactions/': {
      id: '/_private/icash-transactions/'
      path: '/'
      fullPath: '/icash-transactions/'
      preLoaderRoute: typeof PrivateIcashTransactionsIndexRouteImport
      parentRoute: typeof PrivateIcashTransactionsRouteRoute
    }
    '/_private/employees/': {
      id: '/_private/employees/'
      path: '/'
      fullPath: '/employees/'
      preLoaderRoute: typeof PrivateEmployeesIndexRouteImport
      parentRoute: typeof PrivateEmployeesRouteRoute
    }
    '/_private/ateliers/': {
      id: '/_private/ateliers/'
      path: '/'
      fullPath: '/ateliers/'
      preLoaderRoute: typeof PrivateAteliersIndexRouteImport
      parentRoute: typeof PrivateAteliersRouteRoute
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/users/$userId': {
      id: '/_private/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof PrivateUsersUserIdRouteRouteImport
      parentRoute: typeof PrivateUsersRouteRoute
    }
    '/_private/employees/$employeeId': {
      id: '/_private/employees/$employeeId'
      path: '/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof PrivateEmployeesEmployeeIdRouteRouteImport
      parentRoute: typeof PrivateEmployeesRouteRoute
    }
    '/_private/ateliers/$atelierId': {
      id: '/_private/ateliers/$atelierId'
      path: '/$atelierId'
      fullPath: '/ateliers/$atelierId'
      preLoaderRoute: typeof PrivateAteliersAtelierIdRouteRouteImport
      parentRoute: typeof PrivateAteliersRouteRoute
    }
    '/_private/users/$userId/': {
      id: '/_private/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof PrivateUsersUserIdIndexRouteImport
      parentRoute: typeof PrivateUsersUserIdRouteRoute
    }
    '/_private/employees/$employeeId/': {
      id: '/_private/employees/$employeeId/'
      path: '/'
      fullPath: '/employees/$employeeId/'
      preLoaderRoute: typeof PrivateEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof PrivateEmployeesEmployeeIdRouteRoute
    }
    '/_private/ateliers/$atelierId/': {
      id: '/_private/ateliers/$atelierId/'
      path: '/'
      fullPath: '/ateliers/$atelierId/'
      preLoaderRoute: typeof PrivateAteliersAtelierIdIndexRouteImport
      parentRoute: typeof PrivateAteliersAtelierIdRouteRoute
    }
    '/_private/users/$userId/igold-transactions/': {
      id: '/_private/users/$userId/igold-transactions/'
      path: '/igold-transactions'
      fullPath: '/users/$userId/igold-transactions'
      preLoaderRoute: typeof PrivateUsersUserIdIgoldTransactionsIndexRouteImport
      parentRoute: typeof PrivateUsersUserIdRouteRoute
    }
    '/_private/users/$userId/icash-transactions/': {
      id: '/_private/users/$userId/icash-transactions/'
      path: '/icash-transactions'
      fullPath: '/users/$userId/icash-transactions'
      preLoaderRoute: typeof PrivateUsersUserIdIcashTransactionsIndexRouteImport
      parentRoute: typeof PrivateUsersUserIdRouteRoute
    }
    '/_private/employees/$employeeId/salaries/': {
      id: '/_private/employees/$employeeId/salaries/'
      path: '/salaries'
      fullPath: '/employees/$employeeId/salaries'
      preLoaderRoute: typeof PrivateEmployeesEmployeeIdSalariesIndexRouteImport
      parentRoute: typeof PrivateEmployeesEmployeeIdRouteRoute
    }
    '/_private/employees/$employeeId/igold-transactions/': {
      id: '/_private/employees/$employeeId/igold-transactions/'
      path: '/igold-transactions'
      fullPath: '/employees/$employeeId/igold-transactions'
      preLoaderRoute: typeof PrivateEmployeesEmployeeIdIgoldTransactionsIndexRouteImport
      parentRoute: typeof PrivateEmployeesEmployeeIdRouteRoute
    }
    '/_private/employees/$employeeId/icash-transactions/': {
      id: '/_private/employees/$employeeId/icash-transactions/'
      path: '/icash-transactions'
      fullPath: '/employees/$employeeId/icash-transactions'
      preLoaderRoute: typeof PrivateEmployeesEmployeeIdIcashTransactionsIndexRouteImport
      parentRoute: typeof PrivateEmployeesEmployeeIdRouteRoute
    }
    '/_private/ateliers/$atelierId/igold-transactions/': {
      id: '/_private/ateliers/$atelierId/igold-transactions/'
      path: '/igold-transactions'
      fullPath: '/ateliers/$atelierId/igold-transactions'
      preLoaderRoute: typeof PrivateAteliersAtelierIdIgoldTransactionsIndexRouteImport
      parentRoute: typeof PrivateAteliersAtelierIdRouteRoute
    }
    '/_private/ateliers/$atelierId/icash-transactions/': {
      id: '/_private/ateliers/$atelierId/icash-transactions/'
      path: '/icash-transactions'
      fullPath: '/ateliers/$atelierId/icash-transactions'
      preLoaderRoute: typeof PrivateAteliersAtelierIdIcashTransactionsIndexRouteImport
      parentRoute: typeof PrivateAteliersAtelierIdRouteRoute
    }
  }
}

interface PrivateAteliersAtelierIdRouteRouteChildren {
  PrivateAteliersAtelierIdIndexRoute: typeof PrivateAteliersAtelierIdIndexRoute
  PrivateAteliersAtelierIdIcashTransactionsIndexRoute: typeof PrivateAteliersAtelierIdIcashTransactionsIndexRoute
  PrivateAteliersAtelierIdIgoldTransactionsIndexRoute: typeof PrivateAteliersAtelierIdIgoldTransactionsIndexRoute
}

const PrivateAteliersAtelierIdRouteRouteChildren: PrivateAteliersAtelierIdRouteRouteChildren =
  {
    PrivateAteliersAtelierIdIndexRoute: PrivateAteliersAtelierIdIndexRoute,
    PrivateAteliersAtelierIdIcashTransactionsIndexRoute:
      PrivateAteliersAtelierIdIcashTransactionsIndexRoute,
    PrivateAteliersAtelierIdIgoldTransactionsIndexRoute:
      PrivateAteliersAtelierIdIgoldTransactionsIndexRoute,
  }

const PrivateAteliersAtelierIdRouteRouteWithChildren =
  PrivateAteliersAtelierIdRouteRoute._addFileChildren(
    PrivateAteliersAtelierIdRouteRouteChildren,
  )

interface PrivateAteliersRouteRouteChildren {
  PrivateAteliersAtelierIdRouteRoute: typeof PrivateAteliersAtelierIdRouteRouteWithChildren
  PrivateAteliersIndexRoute: typeof PrivateAteliersIndexRoute
}

const PrivateAteliersRouteRouteChildren: PrivateAteliersRouteRouteChildren = {
  PrivateAteliersAtelierIdRouteRoute:
    PrivateAteliersAtelierIdRouteRouteWithChildren,
  PrivateAteliersIndexRoute: PrivateAteliersIndexRoute,
}

const PrivateAteliersRouteRouteWithChildren =
  PrivateAteliersRouteRoute._addFileChildren(PrivateAteliersRouteRouteChildren)

interface PrivateEmployeesEmployeeIdRouteRouteChildren {
  PrivateEmployeesEmployeeIdIndexRoute: typeof PrivateEmployeesEmployeeIdIndexRoute
  PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute: typeof PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute
  PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute: typeof PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute
  PrivateEmployeesEmployeeIdSalariesIndexRoute: typeof PrivateEmployeesEmployeeIdSalariesIndexRoute
}

const PrivateEmployeesEmployeeIdRouteRouteChildren: PrivateEmployeesEmployeeIdRouteRouteChildren =
  {
    PrivateEmployeesEmployeeIdIndexRoute: PrivateEmployeesEmployeeIdIndexRoute,
    PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute:
      PrivateEmployeesEmployeeIdIcashTransactionsIndexRoute,
    PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute:
      PrivateEmployeesEmployeeIdIgoldTransactionsIndexRoute,
    PrivateEmployeesEmployeeIdSalariesIndexRoute:
      PrivateEmployeesEmployeeIdSalariesIndexRoute,
  }

const PrivateEmployeesEmployeeIdRouteRouteWithChildren =
  PrivateEmployeesEmployeeIdRouteRoute._addFileChildren(
    PrivateEmployeesEmployeeIdRouteRouteChildren,
  )

interface PrivateEmployeesRouteRouteChildren {
  PrivateEmployeesEmployeeIdRouteRoute: typeof PrivateEmployeesEmployeeIdRouteRouteWithChildren
  PrivateEmployeesIndexRoute: typeof PrivateEmployeesIndexRoute
}

const PrivateEmployeesRouteRouteChildren: PrivateEmployeesRouteRouteChildren = {
  PrivateEmployeesEmployeeIdRouteRoute:
    PrivateEmployeesEmployeeIdRouteRouteWithChildren,
  PrivateEmployeesIndexRoute: PrivateEmployeesIndexRoute,
}

const PrivateEmployeesRouteRouteWithChildren =
  PrivateEmployeesRouteRoute._addFileChildren(
    PrivateEmployeesRouteRouteChildren,
  )

interface PrivateIcashTransactionsRouteRouteChildren {
  PrivateIcashTransactionsIndexRoute: typeof PrivateIcashTransactionsIndexRoute
}

const PrivateIcashTransactionsRouteRouteChildren: PrivateIcashTransactionsRouteRouteChildren =
  {
    PrivateIcashTransactionsIndexRoute: PrivateIcashTransactionsIndexRoute,
  }

const PrivateIcashTransactionsRouteRouteWithChildren =
  PrivateIcashTransactionsRouteRoute._addFileChildren(
    PrivateIcashTransactionsRouteRouteChildren,
  )

interface PrivateIgoldTransactionsRouteRouteChildren {
  PrivateIgoldTransactionsIndexRoute: typeof PrivateIgoldTransactionsIndexRoute
}

const PrivateIgoldTransactionsRouteRouteChildren: PrivateIgoldTransactionsRouteRouteChildren =
  {
    PrivateIgoldTransactionsIndexRoute: PrivateIgoldTransactionsIndexRoute,
  }

const PrivateIgoldTransactionsRouteRouteWithChildren =
  PrivateIgoldTransactionsRouteRoute._addFileChildren(
    PrivateIgoldTransactionsRouteRouteChildren,
  )

interface PrivateUsersUserIdRouteRouteChildren {
  PrivateUsersUserIdIndexRoute: typeof PrivateUsersUserIdIndexRoute
  PrivateUsersUserIdIcashTransactionsIndexRoute: typeof PrivateUsersUserIdIcashTransactionsIndexRoute
  PrivateUsersUserIdIgoldTransactionsIndexRoute: typeof PrivateUsersUserIdIgoldTransactionsIndexRoute
}

const PrivateUsersUserIdRouteRouteChildren: PrivateUsersUserIdRouteRouteChildren =
  {
    PrivateUsersUserIdIndexRoute: PrivateUsersUserIdIndexRoute,
    PrivateUsersUserIdIcashTransactionsIndexRoute:
      PrivateUsersUserIdIcashTransactionsIndexRoute,
    PrivateUsersUserIdIgoldTransactionsIndexRoute:
      PrivateUsersUserIdIgoldTransactionsIndexRoute,
  }

const PrivateUsersUserIdRouteRouteWithChildren =
  PrivateUsersUserIdRouteRoute._addFileChildren(
    PrivateUsersUserIdRouteRouteChildren,
  )

interface PrivateUsersRouteRouteChildren {
  PrivateUsersUserIdRouteRoute: typeof PrivateUsersUserIdRouteRouteWithChildren
  PrivateUsersIndexRoute: typeof PrivateUsersIndexRoute
}

const PrivateUsersRouteRouteChildren: PrivateUsersRouteRouteChildren = {
  PrivateUsersUserIdRouteRoute: PrivateUsersUserIdRouteRouteWithChildren,
  PrivateUsersIndexRoute: PrivateUsersIndexRoute,
}

const PrivateUsersRouteRouteWithChildren =
  PrivateUsersRouteRoute._addFileChildren(PrivateUsersRouteRouteChildren)

interface PrivateRouteRouteChildren {
  PrivateAteliersRouteRoute: typeof PrivateAteliersRouteRouteWithChildren
  PrivateEmployeesRouteRoute: typeof PrivateEmployeesRouteRouteWithChildren
  PrivateIcashTransactionsRouteRoute: typeof PrivateIcashTransactionsRouteRouteWithChildren
  PrivateIgoldTransactionsRouteRoute: typeof PrivateIgoldTransactionsRouteRouteWithChildren
  PrivateUsersRouteRoute: typeof PrivateUsersRouteRouteWithChildren
  PrivateClientsRoute: typeof PrivateClientsRoute
  PrivateDashboardRoute: typeof PrivateDashboardRoute
  PrivateProductsRoute: typeof PrivateProductsRoute
  PrivateSettingsRoute: typeof PrivateSettingsRoute
  PrivateSuppliersRoute: typeof PrivateSuppliersRoute
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateAteliersRouteRoute: PrivateAteliersRouteRouteWithChildren,
  PrivateEmployeesRouteRoute: PrivateEmployeesRouteRouteWithChildren,
  PrivateIcashTransactionsRouteRoute:
    PrivateIcashTransactionsRouteRouteWithChildren,
  PrivateIgoldTransactionsRouteRoute:
    PrivateIgoldTransactionsRouteRouteWithChildren,
  PrivateUsersRouteRoute: PrivateUsersRouteRouteWithChildren,
  PrivateClientsRoute: PrivateClientsRoute,
  PrivateDashboardRoute: PrivateDashboardRoute,
  PrivateProductsRoute: PrivateProductsRoute,
  PrivateSettingsRoute: PrivateSettingsRoute,
  PrivateSuppliersRoute: PrivateSuppliersRoute,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicTermsRoute: typeof PublicTermsRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicTermsRoute: PublicTermsRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
